import { z } from 'zod';
export const contactConsentChannelSchema = z.enum([
    'sms',
    'whatsapp',
    'email',
    'facebook_messenger',
    'instagram_dm',
]);
export const setContactConsentRequestBase = z
    .object({
    channel: contactConsentChannelSchema,
    enabled: z.boolean(),
    expectedVersion: z.string().regex(/^[a-f0-9]{64}$/),
})
    .strict();
const values = z
    .object({
    sms: z.boolean(),
    whatsapp: z.boolean(),
    email: z.boolean(),
    facebook_messenger: z.boolean(),
    instagram_dm: z.boolean(),
})
    .strict();
export const contactConsentSnapshotSchema = z
    .object({
    values,
    available: values,
    version: z.string().regex(/^[a-f0-9]{64}$/),
})
    .strict();
//# sourceMappingURL=contact-consent.js.map